// extracted by mini-css-extract-plugin
export default {"search":"press-secretaries_search__SujAm","field":"press-secretaries_field__Xkf9D","list":"press-secretaries_list__5I7cK"};